import Vue from "vue";
import VueRouter from "vue-router";

// import Login from "./../components/Login";
// import Secord from "./../views/secord";
// import UserLogin from "./../views/login";

// import globalStore from "./../store/global";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/home",
      name: "共享员工实时动态",
      component: () => import("./../components/Home.vue")
    },
    {
      path: "/",
      name: "企业服务中心",
      component: () => import("./../components/HomeNew.vue")
    },
    {
      path: "/UploadResult",
      name: "提交成功",
      component: () => import("./../components/UploadResult.vue")
    },
    {
      path: "/NeedEmploy",
      name: "企业用工需求",
      component: () => import("./../components/NeedEmploy.vue")
    },
    {
      path: "/ShareEmploy",
      name: "成为共享员工",
      component: () => import("./../components/ShareEmploy.vue")
    },
    {
      path: "/FlexEmploy",
      name: "其它需求",
      component: () => import("./../components/FlexEmploy.vue")
    },
    {
      path: "/polyDetail",
      name: "政策实时查询",
      component: () => import("./../components/polyDetail.vue")
    },
    {
      path: "/SharedDemand",
      name: "企业共享需求",
      component: () => import("./../components/SharedDemand.vue")
    },
    {
      path: "/CollectMessage",
      name: "员工入职健康信息收集",
      component: () => import("./../components/CollectMessage.vue")
    },
    {
      path: "/Search",
      name: "员工入职健康信息查询",
      component: () => import("./../components/Search.vue")
    },
    {
      path: "/QueryRecruitmentInfo",
      name: "员工招聘健康信息查询",
      component: () => import("./../components/QueryRecruitmentInfo.vue")
    },
    {
      path: "/CollectRecruitmentInfo",
      name: "员工健康健康信息查询",
      component: () => import("./../components/CollectRecruitmentInfo.vue")
    },
    {
      path: "/UploadResultSuccess",
      name: "提交成功",
      component: () => import("./../components/UploadResultSuccess.vue")
    },
    // {
    //   path: "/",
    //   name: "登录",
    //   component: () => import("./../components/Login.vue")
    // },
    // {
    //   path: "/Login",
    //   name: "登录",
    //   component: () => import("./../components/Login.vue")
    // },
    // {
    //   path: "/PersonInfor",
    //   name: "个人信息",
    //   component: () => import("./../components/PersonInfor.vue")
    // },
    // // {
    // //   path: "/UploadResume",
    // //   name: "上传简历",
    // //   component: () => import("./../components/UploadResume.vue")
    // // },
    // // // {
    // // //   path: "/Progress",
    // // //   name: "上传简历",
    // // //   component: () => import("./../components/UploadResume.vue")
    // // // },
    // // {
    // //   path: "/UploadSuccess",
    // //   name: "提交成功",
    // //   component: () => import("./../components/UploadResult.vue")
    // // },
    // // {
    // //   path: "/UploadFail",
    // //   name: "提交失败",
    // //   component: () => import("./../components/UploadResult.vue")
    // // },
    // routes: [{
    //         path: "/",
    //         name: "首页",
    //         component: () =>
    //             import ("./../components/Home.vue")
    //     },
    //     {
    //         path: "/ShareEmploy",
    //         name: "成为共享员工",
    //         component: () =>
    //             import ("./../components/ShareEmploy.vue")
    //     },
    //     {
    //         path: "/FlexEmploy",
    //         name: "灵活用工",
    //         component: () =>
    //             import ("./../components/FlexEmploy.vue")
    //     },
    //     {
    //         path: "/polyDetail",
    //         name: "政策实时查询",
    //         component: () =>
    //             import ("./../components/polyDetail.vue")
    //     },
    // {
    //   path: "/",
    //   name: "登录",
    //   component: () => import("./../components/Login.vue")
    // },
    // {
    //   path: "/Login",
    //   name: "登录",
    //   component: () => import("./../components/Login.vue")
    // },
    // {
    //   path: "/PersonInfor",
    //   name: "个人信息",
    //   component: () => import("./../components/PersonInfor.vue")
    // },
    // {
    //   path: "/UploadResume",
    //   name: "上传简历",
    //   component: () => import("./../components/UploadResume.vue")
    // },
    // // {
    // //   path: "/Progress",
    // //   name: "上传简历",
    // //   component: () => import("./../components/UploadResume.vue")
    // // },
    // {
    //   path: "/UploadSuccess",
    //   name: "提交成功",
    //   component: () => import("./../components/UploadResult.vue")
    // },
    // {
    //   path: "/UploadFail",
    //   name: "提交失败",
    //   component: () => import("./../components/UploadResult.vue")
    // },

    // {
    //   path: "/",
    //   name: "政策实时查询",
    //   component: () => import("./../components/polyDetail.vue")
    // },
    // {
    //   path: "/",
    //   name: "登录",
    //   component: () => import("./../components/Login.vue")
    // },
    // {
    //   path: "/Login",
    //   name: "登录",
    //   component: () => import("./../components/Login.vue")
    // },
    // {
    //     path: "/PersonInfor",
    //     name: "个人信息",
    //     component: () =>
    //         import ("./../components/PersonInfor.vue")
    // },
    // {
    //   path: "/UploadResume",
    //   name: "上传简历",
    //   component: () => import("./../components/UploadResume.vue")
    // },
    // // {
    // //   path: "/Progress",
    // //   name: "上传简历",
    // //   component: () => import("./../components/UploadResume.vue")
    // // },
    // {
    //   path: "/UploadSuccess",
    //   name: "提交成功",
    //   component: () => import("./../components/UploadResult.vue")
    // },
    // {
    //   path: "/UploadFail",
    //   name: "提交失败",
    //   component: () => import("./../components/UploadResult.vue")
    // },
  ]
});

export default router;
